import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Playlist } from '../../models/playlist';
import { PlaylistsService } from '../../services/playlists.service';
import { PlaylistService } from '../../services/playlist.service';
import { PlaylistComponent } from '../playlist/playlist.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { AddplaylistComponent } from "../addplaylist/addplaylist.component";


@Component({
  selector: 'app-playlists',
  standalone: true,
  imports: [CommonModule, PlaylistComponent, MatGridListModule, AddplaylistComponent],

  templateUrl: './playlists.component.html',
  styleUrl: './playlists.component.css',
})
export class PlaylistsComponent implements OnInit{

  playlists: WritableSignal<Playlist[]> = signal([]);

  private playlistsService = inject(PlaylistsService);

  ngOnInit() {
    this.getPlaylists();
  }

  getPlaylists(){
    this.playlistsService.getPlaylists().subscribe({
      next: (playlists: Playlist[]) => {
        this.playlists.set(playlists);
        console.log('Playlists fetched successfully:', this.playlists);
      },
      error: (error: any) => {
        console.error('Failed to fetch playlists:', error);
      }
    });
  }
  //testing

}
